// extracted by mini-css-extract-plugin
export default {"container":"fr-z","brandName":"gr-z","productName":"hr-z","productNamePdpEnhancements":"ir-z","breakLongProductName":"jr-z"};